import React from "react";

import "./box-icon.scss";
const BoxIcon = ({type}) => {
    return <div className={"f-box-icon " + type}></div>
}

export default BoxIcon;